import React from 'react';
import getOpCoRoutes from 'getOpCoRoutes';

/**
 * Get route config object by url and language code.
 *
 * @param {String} language
 *   Language code.
 * @param {String} url
 *   The URL
 * @returns {Object|null}
 *   Config object for given url and language if exists or null.
 */
function getRouteFromUrl(language, url) {
  const clientRoutes = getOpCoRoutes()[language] || {};
  const routeNames = Object.keys(clientRoutes);
  let route = null;

  for (let i = 0; i < routeNames.length; i += 1) {
    const routeName = routeNames[i];
    if (clientRoutes[routeName].url === url) {
      route = { routeName, ...clientRoutes[routeName] };
      break;
    }
  }

  return route;
}

export default getRouteFromUrl;
